import { render, staticRenderFns } from "./supplierNewsCategories.vue?vue&type=template&id=d1d38644&"
import script from "./supplierNewsCategories.vue?vue&type=script&lang=js&"
export * from "./supplierNewsCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports